webpackJsonp([208519559027039],{

/***/ 464:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ResearchStaticCard = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styles = __webpack_require__(466);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResearchStaticCardComponent = function (_React$PureComponent) {
		_inherits(ResearchStaticCardComponent, _React$PureComponent);
	
		function ResearchStaticCardComponent() {
			_classCallCheck(this, ResearchStaticCardComponent);
	
			return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
		}
	
		ResearchStaticCardComponent.prototype.render = function render() {
			var _props = this.props,
			    title = _props.title,
			    collaborations = _props.collaborations,
			    body = _props.body;
	
	
			return _react2.default.createElement(
				'article',
				{ className: _styles.wrapperStyle, 'data-component': 'Card' },
				_react2.default.createElement(
					'h1',
					{ className: _styles.titleStyle },
					title
				),
				collaborations && _react2.default.createElement(
					'h2',
					{ className: _styles.collaborationsStyle },
					collaborations
				),
				_react2.default.createElement('div', { className: _styles.bodyStyle, dangerouslySetInnerHTML: { __html: body } })
			);
		};
	
		return ResearchStaticCardComponent;
	}(_react2.default.PureComponent);
	
	ResearchStaticCardComponent.propTypes = {
		title: _propTypes2.default.string,
		collaborations: _propTypes2.default.string,
		body: _propTypes2.default.string
	};
	
	var ResearchStaticCard = exports.ResearchStaticCard = ResearchStaticCardComponent;

/***/ }),

/***/ 465:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _component = __webpack_require__(464);
	
	Object.keys(_component).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _component[key];
	    }
	  });
	});

/***/ }),

/***/ 466:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.bodyStyle = exports.collaborationsStyle = exports.titleStyle = exports.wrapperStyle = undefined;
	
	var _css, _css2, _css3;
	
	var _emotion = __webpack_require__(6);
	
	var _globalStyles = __webpack_require__(4);
	
	var padding = 24;
	
	var wrapperStyle = /*#__PURE__*/exports.wrapperStyle = (0, _emotion.css)((_css = {
		position: 'relative',
		textDecoration: 'none',
		border: '1px solid ' + _globalStyles.lightGrey,
		borderRadius: '6px',
		padding: padding + 'px',
		backgroundColor: '#fff',
		boxSizing: 'border-box',
		zIndex: '1'
	}, _css['@media (max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
		padding: '14px'
	}, _css));
	
	var titleStyle = exports.titleStyle = (0, _emotion.cx)(_globalStyles.headingSmallLight, /*#__PURE__*/(0, _emotion.css)((_css2 = {}, _css2['@media (max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
		fontSize: '14px',
		lineHeight: '17px'
	}, _css2)));
	
	var collaborationsStyle = exports.collaborationsStyle = (0, _emotion.cx)(_globalStyles.headingSmallLight, /*#__PURE__*/(0, _emotion.css)((_css3 = {
		marginTop: padding / 2,
		color: _globalStyles.pink
	
	}, _css3['@media (max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
		fontSize: '14px',
		lineHeight: '17px'
	}, _css3)));
	
	var bodyStyle = exports.bodyStyle = (0, _emotion.cx)(_globalStyles.textBlock, /*#__PURE__*/(0, _emotion.css)({
		marginTop: padding
	}));

/***/ }),

/***/ 486:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.cardSectionStyle = exports.contentSectionStyle = exports.currentResearchWrapperStyle = exports.innerWrapperStyle = exports.textStyle = exports.subTitleStyle = exports.titleStyle = undefined;
	
	var _emotion = __webpack_require__(6);
	
	var _globalStyles = __webpack_require__(4);
	
	var titleStyle = exports.titleStyle = _globalStyles.headingLarge;
	
	var subTitleStyle = exports.subTitleStyle = _globalStyles.headingMedium;
	
	var textStyle = exports.textStyle = (0, _emotion.cx)(_globalStyles.textBlock, /*#__PURE__*/(0, _emotion.css)({
		'& p': {
			maxWidth: '800px'
		}
	}));
	
	var innerWrapperStyle = /*#__PURE__*/exports.innerWrapperStyle = (0, _emotion.css)({
		maxWidth: _globalStyles.desktopMaxWidthBreakpoint,
		width: '100%',
		height: '100%',
		margin: '0 auto',
		padding: '0 20px',
		overflowX: 'hidden'
	});
	
	var currentResearchWrapperStyle = exports.currentResearchWrapperStyle = (0, _emotion.cx)((0, _globalStyles.cardSection)(60), /*#__PURE__*/(0, _emotion.css)({
		marginTop: 0
	}));
	
	var contentSectionStyle = exports.contentSectionStyle = _globalStyles.contentSection;
	
	var cardSectionStyle = exports.cardSectionStyle = _globalStyles.cardSection;

/***/ }),

/***/ 1127:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _link = __webpack_require__(9);
	
	var _reactHelmet = __webpack_require__(8);
	
	var _resourceLibraryManager = __webpack_require__(74);
	
	var _navManager = __webpack_require__(22);
	
	var _pageHeader = __webpack_require__(19);
	
	var _pageNav = __webpack_require__(27);
	
	var _cards = __webpack_require__(17);
	
	var _resourceCard = __webpack_require__(30);
	
	var _researchStaticCard = __webpack_require__(465);
	
	var _bg = __webpack_require__(435);
	
	var _bg2 = _interopRequireDefault(_bg);
	
	var _globalStyles = __webpack_require__(4);
	
	var _research = __webpack_require__(486);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResourcePropType = _propTypes2.default.shape({
		id: _propTypes2.default.string,
		title: _propTypes2.default.string,
		type: _propTypes2.default.string,
		date: _propTypes2.default.string,
		fields: _propTypes2.default.shape({
			thumbnail_image: _propTypes2.default.shape({
				childImageSharp: _propTypes2.default.shape({
					resize: _propTypes2.default.shape({
						src: _propTypes2.default.string.isRequired
					}).isRequired
				}).isRequired
			}).isRequired
		}).isRequired,
		attachments: _propTypes2.default.arrayOf(_propTypes2.default.shape({
			vimeo_url: _propTypes2.default.string
		}))
	});
	
	var ResearchPage = function (_React$PureComponent) {
		_inherits(ResearchPage, _React$PureComponent);
	
		function ResearchPage() {
			_classCallCheck(this, ResearchPage);
	
			return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
		}
	
		ResearchPage.prototype.render = function render() {
			var _ref;
	
			var pageSettings = this.props.data.page.edges[0].node;
	
			var resources = [pageSettings.resource_1, pageSettings.resource_2, pageSettings.resource_3, pageSettings.resource_4];
	
			return _react2.default.createElement(
				_react2.default.Fragment,
				null,
				_react2.default.createElement(
					_reactHelmet.Helmet,
					{ title: pageSettings.purple_heading },
					_react2.default.createElement('meta', { property: 'og:type', content: 'website' }),
					_react2.default.createElement('meta', { property: 'og:title', content: pageSettings.purple_heading }),
					_react2.default.createElement('meta', { name: 'description', content: pageSettings.purple_body }),
					_react2.default.createElement('meta', { property: 'og:description', content: pageSettings.purple_body })
				),
				_react2.default.createElement(_pageHeader.PageHeader, {
					background: _globalStyles.purple + ' url(' + _bg2.default + ') no-repeat bottom right',
					titleText: pageSettings.purple_heading,
					titleTextColor: '#fff',
					subTitleText: pageSettings.purple_body,
					subTitleTextColor: '#fff',
					pageNav: _react2.default.createElement(_pageNav.PageNav, {
						textColor: '#fff',
						activeTextColor: '#fff',
						activeUnderlineColor: _globalStyles.burnedOrange,
						links: [{
							to: '/research',
							text: 'Research at InsideOut',
							active: true
						}, {
							to: '/research/trials',
							text: 'Research Trials Noticeboard'
						}, {
							to: '/research-positions',
							text: 'Research Positions'
						}]
					})
				}),
				_react2.default.createElement(
					'section',
					{ className: (0, _research.contentSectionStyle)('#fff') },
					_react2.default.createElement(
						'div',
						{ className: _research.innerWrapperStyle },
						_react2.default.createElement(
							'header',
							null,
							_react2.default.createElement(
								'h1',
								{ className: _research.titleStyle },
								pageSettings.heading
							)
						),
						_react2.default.createElement('div', { className: _research.textStyle, dangerouslySetInnerHTML: { __html: pageSettings.body } })
					)
				),
				pageSettings.current_research && pageSettings.current_research.length && _react2.default.createElement(
					'section',
					null,
					_react2.default.createElement(
						'div',
						{ className: _research.innerWrapperStyle },
						_react2.default.createElement(
							'div',
							{ className: _research.currentResearchWrapperStyle },
							_react2.default.createElement(
								'header',
								null,
								_react2.default.createElement(
									'h1',
									{ className: _research.subTitleStyle },
									pageSettings.current_research_heading
								)
							),
							_react2.default.createElement(
								_cards.Cards,
								{
									columns: 3,
									scrollable: false,
									columnsAt: (_ref = {}, _ref['max-width: ' + _globalStyles.tabletLandscapeMaxWidthBreakpoint] = 2, _ref['max-width: ' + _globalStyles.tabletPortraitMaxWidthBreakpoint] = 1, _ref)
								},
								pageSettings.current_research.map(function (currentResearch, i) {
									return _react2.default.createElement(_researchStaticCard.ResearchStaticCard, {
										key: i,
										title: currentResearch.heading,
										collaborations: currentResearch.collaborations,
										body: currentResearch.body
									});
								})
							)
						)
					)
				),
				_react2.default.createElement(
					'section',
					{ className: (0, _research.contentSectionStyle)('#F6F6F6', '100px') },
					_react2.default.createElement(
						'div',
						{ className: _research.innerWrapperStyle },
						_react2.default.createElement(
							'div',
							{ className: (0, _research.cardSectionStyle)() },
							_react2.default.createElement(
								'header',
								null,
								_react2.default.createElement(
									'h1',
									{ className: _research.subTitleStyle },
									'InsideOut Publications'
								),
								_react2.default.createElement(
									_link.Link,
									{ to: (0, _resourceLibraryManager.linkWithQueryParams)((0, _resourceLibraryManager.queryParamsFromFilters)({ audience: 'researchers', type: 'publications' })) },
									'View all'
								)
							),
							_react2.default.createElement(
								_cards.Cards,
								{ columns: 4 },
								resources.map(function (node) {
									return node && _react2.default.createElement(_resourceCard.ResourceCard, {
										key: node.id,
										to: (0, _navManager.idToLink)(node.id),
										audiences: (0, _resourceLibraryManager.extractAudiences)(node.categories),
										title: node.title,
										body: node.extract,
										date: node.date
									});
								})
							)
						)
					)
				)
			);
		};
	
		return ResearchPage;
	}(_react2.default.PureComponent);
	
	ResearchPage.propTypes = {
		data: _propTypes2.default.shape({
			page: _propTypes2.default.shape({
				edges: _propTypes2.default.arrayOf(_propTypes2.default.shape({
					node: _propTypes2.default.shape({
						purple_heading: _propTypes2.default.string.isRequired,
						purple_body: _propTypes2.default.string.isRequired,
						heading: _propTypes2.default.string.isRequired,
						body: _propTypes2.default.string.isRequired,
						current_research_heading: _propTypes2.default.string.isRequired,
						current_research: _propTypes2.default.arrayOf(_propTypes2.default.shape({
							heading: _propTypes2.default.string.isRequired,
							body: _propTypes2.default.string.isRequired
						})),
						research_trials_noticeboard_heading: _propTypes2.default.string.isRequired,
						research_tile_heading: _propTypes2.default.string.isRequired,
						research_tile_body: _propTypes2.default.string.isRequired,
						research_positions_heading: _propTypes2.default.string.isRequired,
						research_positions_tile_heading: _propTypes2.default.string.isRequired,
						research_positions_tile_body: _propTypes2.default.string.isRequired,
	
						resource_1: ResourcePropType,
						resource_2: ResourcePropType,
						resource_3: ResourcePropType,
						resource_4: ResourcePropType
					})
				}))
			})
		})
	};
	exports.default = ResearchPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-research-index-js-c2848160766636c5061d.js